<template>
<div id="main" class="column is-9">
			<!-- Begin Greeting -->
<section class="hero is-info welcome is-small">
<div class="columns">
	<div class="column">
		<div class="hero-body">
			<div class="columns">
				<div class="column">
					<h1 class="title">Welcome Back, {{ psychic.firstName }}</h1>
				</div>
			</div>
		</div>
	</div>
</div>
</section>
		<Spinner size="huge" v-if="!idle"></Spinner>
			<section class="profile-box" v-if="idle">
			<div class="columns">
				<div class="column">
						<article class="media">
						<div class="media-content">
							<div class="content">
								<div class="columns is-multiline">
	<div class="column">
		<div class="media-left">
			<div class="image is-responsive">
				<img :src="psychicImage" alt="Image" />
			</div>
		</div>
	</div>
	<div class="column is-hidden-mobile">
			<h4>{{ psychic.username }}</h4>
			<span class="psychic-name">{{ psychic.firstName + ` ` + psychic.lastName }}</span><br>
			<span class="email-add">{{ psychic.email }}</span><br>
			<span class="phone-num">{{ psychic.phone }}</span><br>
			<span class="psychic-ext">Psychic ext: {{ psychic.ext }}</span>
	</div>
	<div class="column has-text-centered">
		<ul>
			<li><router-link to="/psychic">Home</router-link></li>
			<li><router-link to="/psychic/customers">Customers</router-link></li>
			<li><router-link to="/psychic/profile">Profile</router-link></li>
			<li><router-link to="/psychic/listing">Listing</router-link></li>
			<li><router-link to="/psychic/statistics">Statistics</router-link></li>
			<li><router-link to="/psychic/readings">Readings</router-link></li>
			<li><router-link to="/psychic/logins">Login History</router-link></li>
			<li><router-link to="/psychic/schedule">Schedule</router-link></li>
		</ul>
</div></div>							</div>
						</div>
						</article>
				</div>
			</div>
			</section>
			<!-- End Profile header -->
			<section class="info-tiles" v-if="idle">
			<div class="columns is-widescreen">
				<div class="column">
					<div class="tile is-ancestor is-desktop has-text-centered">
						<div class="tile is-parent no-padding-top" v-if="psychic.acctStatus === 'Active'">
							<article class="tile is-child">
							<div class="tile-header">
								<span class="title">Current Status</span>
							</div>
							<div class="tile-content">
								<span :class=statusLabel.css>{{ statusLabel.text }}</span>
								<br>
								<p>
									To change, please select your desired status.
								</p>
								<div class="field is-maxed" v-if="['A', 'P', 'C', 'O', 'U'].includes(status)">
									<div class="control is-expanded has-icons-left">
										<div class="select is-fullwidth is-small">
											<span class="select is-small">
											<select :value="status" @change="changeStatus">
												<option value="A" v-if="hasPermission('AgentPhone') && hasPermission('AgentChat')">Available (Phone &amp; Chat)</option>
												<option value="P" v-if="hasPermission('AgentPhone')">Available (Phone Only)</option>
												<option value="C" v-if="hasPermission('AgentChat')">Available (Chat Only)</option>
												<option value="O">On Alert</option>
												<option value="U">Unavailable</option>
											</select>
											</span>
											<span class="icon is-small is-left">
											<i class="fa fa-bolt"></i>
											</span>
										</div>
									</div>
								</div>
								<div class="field is-narrow" v-if="['A', 'P', 'C', 'O', 'U'].includes(status)">
									<label class="label has-text-weight-normal">We will call you at:</label>
									<div class="field has-addons is-maxed">
										<p class="control is-expanded">
											<span class="select is-small is-expanded">
											<select @change="setPreferred">
												<option v-for="phone in phones" :key="phone.id" :value="phone.id" :selected="phone.preferred">{{ formatPhone(phone.phone_number) }}</option>
											</select>
											</span>
										</p>
									</div>
									<p>
										To change, select an existing number
									</p>
								</div>
							</div>
							</article>
						</div>
						<div class="tile is-parent">
							<article class="tile is-child">
							<div class="tile-header">
								<span class="title">Calls Scheduled</span>
							</div>
							<div class="tile-content">
								<p class="subtitle">
									<div v-if="scheduled.length == 0"><span>No calls currently scheduled.</span><br></div>
									<div v-for="(scheduled, idx) in scheduled" :key="idx">
										<span class="has-text-weight-bold">{{ scheduled.username }}</span>
									</div>
							</div>
							</article>
						</div>
						<div class="tile is-parent">
							<article class="tile is-child">
							<div class="tile-header">
								<span class="title">My Stats</span>
							</div>
							<div class="tile-content">
								<label class="label">My Stats</label>
								<div class="field is-maxed">
									<div class="control has-icons-left is-expanded">
										<div class="select is-narrow is-small">
											<span class="select is-small">
											<select @change="updateStats">
												<option value="today" selected>Today</option>
												<option value="week">The Past Week</option>
												<option value="2week">The Past 2 Weeks</option>
												<option value="month">The Past Month</option>
												<option value="2month">The Past Two Months</option>
											</select>
											</span>
											<span class="icon is-small is-left">
											<i class="fa fa-bar-chart-o"></i>
											</span>
										</div>
									</div>
								</div>
								<div class="field is-maxed">
									<p class="my-stats">
										Phone Minutes: {{ callMins }}<br>
										Chat Minutes: {{ chatMins }}<br>
										Average Customer Rating: {{psychic.avg_rating}}<br>
									</p>
								</div>
							</div>
							</article>
						</div>
					</div>
				</div>
			</div>
			</section>
		</div>
</template>

<script>
	import moment from "moment-timezone"
	import Spinner from 'vue-simple-spinner'

	export default {
		components: {
			Spinner
		},
		data() {
			return {
				user_id: null,
				psychic: {},
				scheduled: [],
				stats: [],
				interval: "",
				phonesOpen: false,
				idle: false,
				scheduledInterval: null,
			}
		},
		methods: {
			async updateStats(e) {
				let start = moment()
				let end = moment()
				switch(e.target.value) {
					case "today":
						break
					case "week":
						start = moment().add(-7, "day")
						break
					case "2week":
						start = moment().add(-14, "day")
						break;
					case "month":
						start = moment().add(-1, "month")
						break;
					case "2month":
						start = moment().add(-2, "month")

				}
				this.stats = await this.$root.$data.getters.getStatisticsSummary(this.$root.$data.state, start, end)
			},
			hasPermission(name) {
				if (this.psychic.permissions == undefined) { return false }
				return this.psychic.permissions.includes(name)
			},
			formatPhone(p) {
				const phone = p.toString()
				return `${phone.toString().slice(0, 3)}-${phone.slice(3,6)}-${phone.slice(6)}`
			},
			async setPreferred(e) {
				await this.$root.$data.setters.setPhonePreferred(this.$root.$data.state, this.user_id, parseInt(e.target.value))
			},
			async changeStatus(e) {
				this.$root.$data.setters.setStatus(this.$root.$data.state, this.user_id, e.target.value)
			},
			async updateScheduled() {
				this.scheduled = await this.$root.$data.getters.getScheduled(this.$root.$data.state, this.user_id)  
			}
		},
		computed: {
			statusLabel() {
				switch(this.status) {
					case "A":
					case "C":
					case "P":
						return { text: "Available", css: "tag is-success" }
					case "B":
						return { text: "Busy", css: "tag is-primary" }
					case "R":
						return { text: "Reserved", css: "tag is-light" }
					case "O":
						return { text: "On Alert", css: "tag is-warning" }
					case "U":
						return { text: "Unavailable", css: "tag is-danger" }
					default:
						return { text: "N/A", css: "tag is-danger" }
				}
			},
			callMins() {
				for(let i = 0; i < this.stats.length; i++) {
					if (this.stats[i]["conn_type"] == "Call") {
						return this.stats[i]["bill_mins"]
					}
				}
				return "0"
			},
			chatMins() {
				for(let i = 0; i < this.stats.length; i++) {
					if (this.stats[i]["conn_type"] == "Chat") {
						return this.stats[i]["bill_mins"]
					}
				}
				return "0"
			},
			psychicImage() {
				if (this.psychic.image === null || this.psychic.image === undefined) {
					return "//cdn.asknow.com/Render/images/hq-psychic-photos/png/default-new.png"
				}
				return `//cn.asknow.com/psychic_images/${this.psychic.image.replace('.meditem', '_296.meditem')}`
			},
			status() {
				return this.$root.$data.state.status.data
			}
		},
		async mounted() {
			this.user_id = JSON.parse(localStorage.getItem("user")).user_id
			this.psychic = await this.$root.$data.getters.getPsychic(this.$root.$data.state, this.user_id)  
			this.scheduled = await this.$root.$data.getters.getScheduled(this.$root.$data.state, this.user_id)  
			this.phones = await this.$root.$data.getters.getPhones(this.$root.$data.state, this.user_id)  
			this.stats = await this.$root.$data.getters.getStatisticsSummary(this.$root.$data.state, moment(), moment())
			this.scheduledInterval = setInterval(this.updateScheduled, 60000)
			this.idle = true
		},
		beforeDestroy() {
			clearInterval(this.scheduledInterval)
		}
	}
</script>